export class UserPortalEventRequest {
  username: string;
  completionDate: Date;
}
